<template>
	<form class="content content-500 column detail-page  flexible article" @submit="submitForm">
		<header class="row centering separated">
			<router-link class="rigid" :to="{ path: returnPath }"><i class="fas fa-arrow-left"></i></router-link>
			<h1 class="rigid capitalize">{{pageHeader}}</h1>
		</header>

		<div class="column panel relative">
			<div v-if="paymentMethod" class="current badge badge-muted row separated">
				<span class="rigid">Current:</span>
				<span class="rigid">
					<i class="fab" :class="'fa-cc-' + paymentMethod.brand.toLowerCase()"></i>
					{{paymentMethod.last4}}
				</span>
			</div>
			<div>
				<div class="field" v-if="!storedAddressNotSupported">
					<label for="stripeElement" class="label required">Credit Card</label>
					<section class="stripe-element">
						<stripe-card :reset-stripe="reset" id="stripeElement" v-on:create-token="setCardData"></stripe-card>
					</section>
				</div>
				<div class="notice warning gap above" v-show="addressNotSupported">
					Currently, we are unable to process credit card payments outside the US. <br>To place a purchasing order for any of the packages, please email <a href="mailto:sales@support.tekcloud.com?subject=International%20Payments">sales@support.tekcloud.com</a> or call 1-800-833-9200.
				</div>
				<address-form :is-submitting="submitting" @clear-error="createAddressError = null" :error="createAddressError" v-if="showAddressForm" @change="onAddressChange"></address-form>
			</div>

			<div v-if="addMethodError" class="row">
				<div class="notice error flexible"><p>{{addMethodError.message || addMethodError.type}}</p>
				<p>Please try again or <a :href="'mailto:' + supportEmail + '?subject=Add%20Payment%20Method%20Error'">contact support</a>.</p>
				</div>
			</div>

			<footer class="row separated right centering">
				<router-link class="button rigid" :class="{'disabled':createAddressError}" :to="{ path: returnPath }">Cancel</router-link>
				<submit-button type="submit" class="primary rigid" :button-text="'Add Card'" :submitting-text="'Adding Card'" :is-submitting="submitting" :is-disabled="!tokenId || createAddressError || addressNotSupported || (needsAddress && (!address || !address.complete)) || submitting"></submit-button>
			</footer>
		</div>
	</form>
</template>

<script>
import StripeCard from '../components/StripeCard.vue';
import AddressForm from '../components/AddressForm.vue';
import SubmitButton from '../components/SubmitButton.vue';
import { mapGetters } from 'vuex';
import { default as ENV_VARS } from '@/modules/env-vars.js';

export default {
	name: 'PaymentMethod',
	components:{
		StripeCard,
		SubmitButton,
		AddressForm
	},
	data(){
		return {
			reset: false,
			tokenId: null,
			submitting: false,
			paymentMethodAdded: false,
			addMethodError: null,
			createAddressError: null,
			overrideAddress: false,
			address: null,
			supportedCountries: ['US']
		};
	},
	computed:{
		...mapGetters([
			'user',
			'account',
			'accountStatus',
			'userStatus'
		]),
		supportEmail(){
			return ENV_VARS.SUPPORT_EMAIL;
		},
		returnPath(){
			return this.$route.query.returnPath || '/payments';
		},
		needsAddress() {
			return ENV_VARS.BRAND_ID === 'tekcloud' && !this.user.address;
		},
		storedAddressNotSupported(){
			return this.user.address && this.unsupportedCountry(this.user.address.country);
		},
		newAddressNotSupported(){
			return this.address && this.unsupportedCountry(this.address.country);
		},
		addressNotSupported(){
			return this.storedAddressNotSupported || this.newAddressNotSupported;
		},
		pageHeader(){
			return (this.account.paymentMethod ? 'Change' : 'Add') + ' Payment Method';
		},
		showAddressForm(){
			return !this.userStatus.loading && this.needsAddress && !this.paymentMethodAdded;
		},
		paymentMethod() {
			return this.account && this.account.paymentMethod;
		}
	},
	methods:{
		unsupportedCountry(country){
			return !this.supportedCountries.includes(country);
		},
		setCardData(result) {
			if (result && result.token && result.token.card) {
				this.card = {
					last4: result.token.card.last4,
					brand: result.token.card.brand
				};
			}
			this.tokenId = result && result.token && result.token.id;
		},
		onAddressChange(val){
			this.address = val;
		},
		submitForm(e){
			e.preventDefault();
			let vm = this;
			vm.submitting = true;

			if (this.needsAddress) {
				this.createAddress()
					.then(address => {
						this.$store.dispatch('SET_ADDRESSES', [this.address]);
						this.addPaymentMethod()
							.then(response => {
								this.$router.push(vm.returnPath);
							})
							.catch(reason => {
								vm.addMethodError = reason;
							})
							.finally(()=>{
								vm.submitting = false;
								vm.paymentMethodAdded = true;
							});

					})
					.catch(reason => {
						vm.createAddressError = reason;
						vm.submitting = false;
					});
			} else {
				this.addPaymentMethod()
					.then(response => {
						this.$router.push(vm.returnPath);
					})
					.catch(reason => {
						vm.addMethodError = reason;
					})
					.finally(()=>{
						vm.submitting = false;
					});
			}
		},
		createAddress() {
			return this.$store.dispatch('CREATE_ADDRESS_REQUEST', this.address);
		},
		addPaymentMethod(e) {
			return this.$store.dispatch('payment/ADD_PAYMENT_REQUEST', {
				type: 'stripe',
				token: this.tokenId
			});
		},
		leavePaymentMethod(){
			// this.resetState();
			this.$router.push(this.returnPath);
		},
	},
	mounted() {
		this.reset = true;
	}
};
</script>

<style scoped>
.panel {
	background: white;
	border-radius: 6px;
	padding: 2rem;
	border: 2px solid #dfdfdf;
	width: 100%;
	margin: auto;
	box-sizing: border-box;
}
.dark .panel {
	background: #1a1a1a;
	border: 2px solid #333;
}

.current i {
	margin-right: 4px;
}

.current.badge {
	position: absolute;
    top: 0;
    right: 0;
    left: auto;
	padding: .8em;
	border-top-left-radius: 0;
	border-bottom-right-radius: 0;
}

label.required:after {
	content: ' *';
}

.panel footer {
	margin-top: 2em;
}
</style>



// WEBPACK FOOTER //
// ./src/views/PaymentMethod.vue